import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, map } from 'rxjs';

import { SystemReadyService } from 'src/app/shared/components/system-ready/system-ready.service';
import { SystemUpgradeService } from 'src/app/shared/components/system-upgrade/system-upgrade.service';
import * as fromGlobalStore from 'src/app/stores/global';

type LayoutView = 'ready' | 'initializing' | 'upgrading';
enum LayoutState {
  READY = 'ready',
  UPGRADING = 'upgrading',
  INITIALIZING = 'initializing',
}

@Component({
  selector: 'frodo-default-layout',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
})
export class DefaultLayoutComponent implements OnInit {
  isLoading$ = this.store.select(fromGlobalStore.selectIsLoading);
  readonly viewState$ = combineLatest([
    this.store.select(fromGlobalStore.selectIsUpgradeBlocking),
    this.systemReadyService.isReady$,
  ]).pipe(
    map(([isUpgradeBlocking, isReady]): LayoutView => {
      if (isUpgradeBlocking) return LayoutState.UPGRADING;

      return isReady ? LayoutState.READY : LayoutState.INITIALIZING;
    })
  );

  constructor(
    private systemReadyService: SystemReadyService,
    private systemUpgradeService: SystemUpgradeService,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.systemReadyService.init();
    this.systemUpgradeService.init();
  }
}
